import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Row } from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import { END_POINT } from '../../constants/defaultValues';

const FooterPage = (props) => {
    const [expired, setExpired] = useState(false);
    const [upgraded, setUpgraded] = useState(false);

    useEffect(() => {
        getExpired();
    }, []);

    const getExpired = () => {
        let tokenStr = localStorage.getItem('access_token');
        return Axios.get(`${END_POINT + '/user-license'}`, {
            headers: { Authorization: `Bearer ${tokenStr}` },
        })
            .then((res) => {
                let data = res.data.data;
                setExpired(data.isExpired);
                setUpgraded(data.upgraded);
            })
            .catch((err) => []);
    };

    return (
        <footer className='footer-page'>
            <Row className='pt-4 pb-4'>
                <Colxx xxs='6'>
                    <p className='text-muted mb-0'>
                        <a
                            href='https://vmass.vn'
                            className='text-muted text-small'
                        >
                            Bản quyền thuộc vmass.vn
                        </a>
                    </p>
                </Colxx>
                <Colxx xxs='6' className='d-flex justify-content-end pt-0 pl-0'>
                    {expired && !upgraded ? (
                        <>
                            <i className='simple-icon-diamond line-height-1dot5 pr-1' />
                            <NavLink
                                to='/app/applications/upgrade'
                                className='mb-0 pr-2'
                            >
                                Nâng cấp
                            </NavLink>
                            {' || '}
                        </>
                    ) : null}
                    {props.children}
                </Colxx>
            </Row>
        </footer>
    );
};

export default FooterPage;
